import { mapGetters } from 'vuex';
import { isMarketMaintenance } from '@/utils/helpers';
import smallModal from '@/components/generics/modal/small/small.vue';

export default {
  props: {
    market: {
      type: Object,
      required: true,
    },
  },
  components: {
    smallModal,
  },
  data() {
    return {
      showDetails: false,
    };
  },
  computed: {
    ...mapGetters('app', [
      'isLayoutDesktop', 'isLayoutMobile', 'isCommentEnabled',
      'isAfterHours', 'isRegularMaintenance', 'isExtendedMaintenance',
      'isPinningEnabled', 'hasMaintenance', 'hasMaintenanceSuspended',
    ]),
    show() {
      return !!this.theme;
    },
    theme() {
      if (this.hasMaintenance) {
        return 'maintenance';
      }
      if (isMarketMaintenance(this.market)) {
        return 'maintenance';
      }
      return '';
    },
    title() {
      if (this.hasMaintenanceSuspended) {
        return 'Trading Paused';
      }
      return 'In Maintenance';
    },
    classModifiers() {
      return {
        'market-site-alert-v2': true,
        [`market-site-alert-v2--${this.theme}`]: this.theme,
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/v2/market-site-alert-v2/market-site-alert-v2.js